import { IconComponentType, IconWrapper } from './icon-wrapper'

const IconChevronDown: IconComponentType = ({ className }) => {
  return (
    <IconWrapper className={className}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9982 14.95C11.8648 14.95 11.7398 14.9291 11.6232 14.8875C11.5065 14.8458 11.3982 14.775 11.2982 14.675L6.69816 10.075C6.51482 9.89163 6.41899 9.66246 6.41066 9.38746C6.40232 9.11246 6.49816 8.87496 6.69816 8.67496C6.88149 8.49163 7.11482 8.39996 7.39816 8.39996C7.68149 8.39996 7.91482 8.49163 8.09816 8.67496L11.9982 12.55L15.8982 8.67496C16.0815 8.49163 16.3107 8.3958 16.5857 8.38746C16.8607 8.37913 17.0982 8.47496 17.2982 8.67496C17.4815 8.8583 17.5732 9.09163 17.5732 9.37496C17.5732 9.6583 17.4815 9.89163 17.2982 10.075L12.6982 14.675C12.5982 14.775 12.4898 14.8458 12.3732 14.8875C12.2565 14.9291 12.1315 14.95 11.9982 14.95Z"
          fill="currentColor"
        />
      </svg>
    </IconWrapper>
  )
}

export default IconChevronDown